import React, { createRef, useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Select, Typography } from '@ezetech/swag-space-x';
import classnames from 'classnames';
import { ReactComponent as CopyIcon } from 'assets/svg/copy-icon-small.svg?react';
import { SpaceStyledContentPopup } from 'swag-client-common/components/popups/space-styles-content-popup';
import classes from './store-link-and-make-it-live-popup.scss';
const STATUS = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT'
};
const LABEL = {
  ACTIVE: 'Make site active',
  DRAFT: 'Make site draft'
};
const options = [{
  value: STATUS.ACTIVE,
  label: LABEL.ACTIVE
}, {
  value: STATUS.DRAFT,
  label: LABEL.DRAFT
}];
const ROOT_CBS_DOMAIN = '.swag.site';
const MIN_LINK_CHARACTERS = 5;
const MAX_LINK_CHARACTERS = 60;
const DEFAULT_INPUT_SIZE = 9;
const MIN_INPUT_SIZE = 1;
const validateStoreName = str => {
  if (!str && !(str !== null && str !== void 0 && str.length)) {
    return null;
  }
  if (str.length < MIN_LINK_CHARACTERS) {
    return `A subdomain must be at least ${MIN_LINK_CHARACTERS} characters.`;
  }
  if (str.length > MAX_LINK_CHARACTERS) {
    return `A subdomain must be ${MAX_LINK_CHARACTERS} characters maximum.`;
  }
  const startRegexp = new RegExp(/^[a-z0-9]/, 'g');
  const endRegexp = new RegExp(/[a-z0-9]$/, 'g');
  if (!startRegexp.test(str) || !endRegexp.test(str)) {
    return 'A subdomain must start and end with a letter or a number.';
  }
  const twoConsecutiveSymbolsRegexp = new RegExp(/^(?!.*[-]{2}).*$/, 'g');
  if (!twoConsecutiveSymbolsRegexp.test(str)) {
    return 'Subdomains cannot have two dashes in a row.';
  }
  const regexp = new RegExp(/^(?!.*--)[a-z0-9](?:[a-z0-9-]{0,}[a-z0-9])?$/, 'g');
  if (!regexp.test(str)) {
    return 'A subdomain can include alphanumeric characters (a-z, 0-9) and dashes (-).';
  }
  return null;
};
export const StoreLinkAndMakeItLivePopupComponent = ({
  open,
  storeName,
  errorMessage,
  onConfirmClick,
  onCloseClick,
  onHideError,
  notifyAboutCopy
}) => {
  const [brand, setBrand] = useState(storeName);
  const [status, setStatus] = useState(STATUS.DRAFT);
  const [validationError, setValidationError] = useState('');
  const [isChangedBrand, setIsChangedBrand] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const labelRef = /*#__PURE__*/createRef();
  useEffect(() => {
    const elem = labelRef.current;
    if (elem) {
      elem.dataset.value = brand;
    }
    const validationErrorMsg = validateStoreName(brand);
    if (validationErrorMsg) {
      setValidationError(validationErrorMsg);
    }
  }, [brand]);
  const onBrandChange = e => {
    setIsChangedBrand(true);
    setValidationError('');
    setBrand(e.target.value);
    onHideError();
  };
  const onStatusChange = option => {
    setStatus(option.value);
  };
  const onFocusChange = focused => () => {
    setIsFocused(focused);
  };
  const onClose = () => {
    onCloseClick();
    new Promise(resolve => {
      setTimeout(() => {
        setBrand(storeName);
        setIsChangedBrand(false);
        setStatus(STATUS.ACTIVE);
        resolve(null);
      }, 500);
    });
  };
  const inputSize = isChangedBrand ? brand ? MIN_INPUT_SIZE : DEFAULT_INPUT_SIZE : (storeName === null || storeName === void 0 ? void 0 : storeName.length) || DEFAULT_INPUT_SIZE;
  const isError = Boolean(validationError || errorMessage);
  const getContent = () => /*#__PURE__*/React.createElement("div", {
    className: classes.dialogBody
  }, /*#__PURE__*/React.createElement(Typography, {
    lineHeight: "100%",
    fontType: "bodyMd",
    color: "#6D6D75"
  }, "Awesome! We are almost there to having your amazing curated brand site live. First create your brand site link and where your audience will be directed to. Then you can decide if you want to make the site active or keep it in draft so that you can continue to make edits."), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.inputLabel
  }, "Brand Site Link"), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.inputBody, {
      [classes.errorBackground]: isError && !isFocused
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.link,
    lineHeight: "100%",
    fontType: "bodyMd",
    color: "#6D6D75"
  }, /*#__PURE__*/React.createElement("label", {
    className: classes.input,
    ref: labelRef
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    size: inputSize,
    maxLength: MAX_LINK_CHARACTERS + 1,
    placeholder: "Enter brand",
    value: brand,
    onChange: onBrandChange,
    onFocus: onFocusChange(true),
    onBlur: onFocusChange(false),
    className: classes.storePrefixName
  })), ROOT_CBS_DOMAIN), /*#__PURE__*/React.createElement("div", {
    className: classes.copy
  }, /*#__PURE__*/React.createElement(CopyToClipboard, {
    onCopy: notifyAboutCopy,
    text: `${brand}${ROOT_CBS_DOMAIN}`
  }, /*#__PURE__*/React.createElement(CopyIcon, {
    className: classes.copyIcon
  })))), isError && /*#__PURE__*/React.createElement(Typography, {
    fontType: "bodySm",
    color: "#D83A52"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.errorMsg
  }, validationError || errorMessage))), /*#__PURE__*/React.createElement(Select, {
    name: "siteStatus",
    label: "Status",
    options: options,
    value: {
      value: status,
      label: LABEL[status]
    },
    onChange: onStatusChange
  }));
  const isContinueDisabled = Boolean(!brand || validationError || errorMessage);
  return /*#__PURE__*/React.createElement(SpaceStyledContentPopup, {
    open: open,
    title: "Store link & make it live",
    onConfirmClick: () => onConfirmClick({
      link: brand,
      status
    }),
    onCloseClick: onClose,
    content: getContent(),
    continueBtnText: "Save",
    isContinueDisabled: isContinueDisabled,
    contentWrapperClassName: classes.contentWrapper,
    dialogWrapperClassName: classes.dialogWrapper,
    footerClassName: classes.footer
  });
};